'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _app = require('firebase/app');

var firebase = _interopRequireWildcard(_app);

require('firebase/auth');

var _components = require('components');

var _reactRedux = require('react-redux');

var _analytics = require('redux/modules/analytics');

var analyticsAction = _interopRequireWildcard(_analytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirebaseAuth = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggingIn: state.auth.loggingIn
  };
}, { submitAnalyticsAction: analyticsAction.submitAnalyticsAction }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FirebaseAuth, _Component);

  function FirebaseAuth(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, FirebaseAuth);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FirebaseAuth.__proto__ || (0, _getPrototypeOf2.default)(FirebaseAuth)).call(this, props));

    _this.signIn = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(prefix, number) {
        var _this$props, isBooking, desktopMode, phoneNumber, confirmationResult;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, isBooking = _this$props.isBooking, desktopMode = _this$props.desktopMode;

                _this.setState({ isSendingSMS: true });
                _context.prev = 2;
                phoneNumber = prefix + number;

                window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', { size: 'invisible' });
                _context.next = 7;
                return firebase.auth().signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier);

              case 7:
                confirmationResult = _context.sent;


                if (confirmationResult) {
                  window.recaptchaVerifier.clear();
                  _this.setState({
                    confirmationResult: confirmationResult,
                    isEnterCode: true,
                    isSendingSMS: false
                  });
                } else {
                  _this.setState({ isSendingSMS: false });
                }
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);

                _this.setState({ isSendingSMS: false, isSendingError: true });
                _this.props.submitAnalyticsAction({
                  actionName: !isBooking ? 'login_firebase' : 'booking_login_firebase',
                  origin: desktopMode ? 'web' : 'mobile-web',
                  originURL: '',
                  phoneNumber: prefix + number,
                  platform: navigator.userAgent,
                  error: _context.t0.message
                });
                console.log(_context.t0);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 11]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.submitCode = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(code) {
        var confirmationResult, result, idToken;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                confirmationResult = _this.state.confirmationResult;

                _this.setState({ submitCode: true });
                _context2.next = 5;
                return confirmationResult.confirm(code);

              case 5:
                result = _context2.sent;
                _context2.next = 8;
                return result.user.getIdToken();

              case 8:
                idToken = _context2.sent;

                _this.props.onResponse(idToken);
                _context2.next = 17;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                alert('Mã xác nhận không đúng. Vui lòng thử lại');
                _this.setState({ submitCode: false });

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 12]]);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.onHide = function () {
      _this.setState({ showModal: false, isEnterCode: false });
    };

    _this.onShow = function () {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.setState({ showModal: true });
      }
    };

    _this.state = {
      isSendingSMS: false,
      isSendingError: false,
      showModal: false,
      submitCode: false,
      isEnterCode: false,
      confirmationResult: null,
      loginTooMuch: false
    };
    return _this;
  }

  (0, _createClass3.default)(FirebaseAuth, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      firebase.auth().useDeviceLanguage();
      firebase.auth().settings.appVerificationDisabledForTesting = process.env.FIREBASE_CAPTCHA_DISABLED_FOR_TESTING === 'true';
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.loggingIn) {
        this.setState({ submitCode: false });
      }
    }
  }, {
    key: 'isSending',
    value: function isSending() {
      this.setState({ isSendingSMS: true });
    }
  }, {
    key: 'stopSending',
    value: function stopSending() {
      this.setState({ isSendingSMS: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showModal = _state.showModal,
          isEnterCode = _state.isEnterCode,
          submitCode = _state.submitCode,
          isSendingError = _state.isSendingError,
          isSendingSMS = _state.isSendingSMS;
      var _props = this.props,
          desktopMode = _props.desktopMode,
          isBooking = _props.isBooking;

      if (submitCode) {
        return _react2.default.createElement(_components.Loading, null);
      }
      return _react2.default.createElement(
        'div',
        { onClick: this.onShow },
        this.props.children(),
        _react2.default.createElement(_components.FirebasePhoneAuth, {
          desktopMode: desktopMode,
          show: showModal,
          onHide: this.onHide,
          onVerifyPhone: this.signIn,
          onSubmitCode: this.submitCode,
          isEnterCode: isEnterCode,
          phone: this.props.phone,
          isBooking: isBooking,
          isSendingError: isSendingError,
          isSendingSMS: isSendingSMS
        })
      );
    }
  }]);
  return FirebaseAuth;
}(_react.Component), _class2.propTypes = {
  desktopMode: _propTypes2.default.bool,
  children: _propTypes2.default.func,
  className: _propTypes2.default.string,
  onResponse: _propTypes2.default.func,
  submitAnalyticsAction: _propTypes2.default.func,
  text: _propTypes2.default.string,
  hasIcon: _propTypes2.default.bool,
  phone: _propTypes2.default.string,
  loggingIn: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  isBooking: _propTypes2.default.bool
}, _temp)) || _class);
exports.default = FirebaseAuth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/FirebaseAuth.js
// module id = 123
// module chunks = 0